import React from 'react'
import { useParams } from 'react-router-dom'
import EditClassificationRuleWorkflow from 'application/categories/EditClassificationRuleWorkflow'

function EditClassificationRuleScreen() {
    const { id } = useParams<{ id: string }>()
    return <EditClassificationRuleWorkflow onSuccess="/classification-rules" entryId={parseInt(id!)} static={true} />
}

export default EditClassificationRuleScreen
